import React, { useContext, useEffect, useState } from "react";
import SetupTittle from "../SharedComponents/SetupTittle";
import SetupContainer from "../SharedComponents/SetupContainer";
import SetupInput from "../SharedComponents/SetupInput";
import SetupRadio from "../SharedComponents/SetupRadio";
import SubmitBtn from "../SharedComponents/SubmitBtn";
import SetupDropDown from "../SharedComponents/SetupDropdown";
import axios from "axios";
import HistoryTable from "../SharedComponents/HistoryTable";
import Box from "../SharedComponents/Box";
import Swal from "sweetalert2";
import GetLocalStorageUserId from "../../sharedComponents/GetLocalStorageuserId";
import { contextProvider } from "../SetupPagesContextApi/SetupPagesContextApi";

const ItmeCategory = () => {
  const backendUrl = process.env.REACT_APP_API_URL;
  const [fetchedData, setFetchedData] = useState([]);
  const [refetch, setRefetch] = useState(false);
  useEffect(() => {
    axios
      .get(`${backendUrl}ItemCategory`)
      .then((res) => setFetchedData(res.data))
      .catch((err) => console.log(err.message));
  }, [backendUrl, refetch]);
  // input fields handle.
  const initialValue = {
    id: 0,
    companyId: 0,
    name: "",
    cost: 0,
    routeId: 0,
    isActive: "",
    creatorId: GetLocalStorageUserId(),
    creationDate: new Date(),
    modifierId: GetLocalStorageUserId(),
    modificationDate: new Date(),
    // branchId: "",
    // branchName: "string",
  };

  const [formData, setFormData] = useState(initialValue);
  const [willUpdate, setWillUpdate] = useState(false);

  const update = (data) => {
    setFormData({ ...formData, ...data });
  };
  const { handleDataReload } = useContext(contextProvider);
  const formHandle = (e) => {
    e.preventDefault();
    console.log({ ...formData });

    if (!willUpdate) {
      axios
        .post(`${backendUrl}ItemCategory`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 201 || res.status === 204) {
            Swal.fire({
              title: `Item Category Created Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => {
          console.log(err.message);
          Swal.fire({
            title: `Error creating Item Category`,
            text: err.message || "Please try again",
            icon: "error",
          });
        });
    }

    if (willUpdate) {
      console.log(formData);
      axios
        .put(`${backendUrl}ItemCategory/${formData.id}`, { ...formData })

        .then((res) => {
          console.log(res);
          if (res.status === 204) {
            Swal.fire({
              title: `Item Category Updated Successfully`,
              icon: "success",
            });
            setRefetch((prev) => !prev);
            setFormData(initialValue);
            setWillUpdate(false);
            handleDataReload();
          }
        })
        .catch((err) => console.log(err.message));
    }
  };
  return (
    <div>
      <Box top>
        <SetupTittle text="Item category" />
        <SetupContainer>
          <form className="" onSubmit={formHandle}>
            <div className="grid lg:grid-cols-2 gap-y-4 grid-cols-1 lg:gap-y-[35px] lg:gap-x-[125px]">
              <SetupInput
                name="name"
                type="text"
                placeHolder="Item category name"
                allTimeValue={formData.name}
                valueUpdate={(e) => update({ name: e.target.value })}
              />
              {/* <SetupDropDown
                dataOf="company"
                allTimeValue={formData.companyId}
                valueUpdate={(e) =>
                  update({ companyId: parseInt(e.target.value) })
                }
                placeHolder="Company name"
                name="companyId"
              ></SetupDropDown> */}
              {/* <SetupDropDown // need to change
                dataOf="branch"
                allTimeValue={formData.branchId}
                valueUpdate={(e) =>
                  update({ branchId: parseInt(e.target.value) })
                }
                placeHolder="Branch"
                name="branchId"
              ></SetupDropDown> */}
              
              <SetupInput
                name="cost"
                type="number"
                placeHolder="Cost"
                allTimeValue={formData.cost}
                valueUpdate={(e) => update({ cost: e.target.value })}
              />
               <SetupDropDown
                  name="routeName"
                  placeHolder="Route name"
                  dataOf="route"
                  allTimeValue={formData.routeId}
                  valueUpdate={(e) =>
                    update({ routeId: parseInt(e.target.value) })
                  }
                ></SetupDropDown>


                <SetupRadio
                name="isActive"
                placeHolder="Item category status?"
                allTimeValue={formData.isActive}
                valueUpdate={(data) => update({ isActive: data })}
              />

            </div>
            <SubmitBtn text={willUpdate ? "Update" : "Create"} />
            <SubmitBtn
              onClick={() => {
                setWillUpdate(false);
                update(initialValue);
              }}
              styleClass={!willUpdate && "hidden"}
              text="Cancel"
            />
          </form>
        </SetupContainer>
      </Box>
      <Box>
        <SetupTittle text="History" />
        <SetupContainer>
          <HistoryTable
            editCallBack={(data) => {
              update(data);
              setWillUpdate(true);
            }}
            fetchedData={fetchedData}
            headers={["Item category name", 
              "Cost",
              "Route",
              // "Company name",
              // "Branch",
                "Status"]}
            row={["name",
              "cost",
              "routeName",
              //  "companyId",
             //  "branchName",
                "isActive"]}
            extraFields={["branchId", "routeId"]}
          />
        </SetupContainer>
      </Box>
    </div>
  );
};

export default ItmeCategory;
